import { Component } from '@angular/core';

@Component({
  templateUrl: './container.component.html',
})
export class ContainerComponent {}
